(function () {
  function initFragrancePack(root) {
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    const maxSelection = parseInt(root.dataset.maxSelection || "4", 10);
    const rawOptions = JSON.parse(root.dataset.options || "[]");

    const options = rawOptions.map((item) => {
      if (typeof item === "string") {
        return { name: item, image: "" };
      }
      return {
        name: item.name || "",
        image: item.image || ""
      };
    });

    const modal = root.querySelector(".manish-fragrance-pack__modal");
    const overlayCloseEls = root.querySelectorAll("[data-close-modal]");
    const openBtn = root.querySelector(".manish-fragrance-pack__open");
    const editBtn = root.querySelector(".manish-fragrance-pack__edit-link");
    const confirmBtn = root.querySelector(".manish-fragrance-pack__confirm");
    const optionsWrap = root.querySelector(".manish-fragrance-pack__options");
    const selectedCountEl = root.querySelector(".manish-fragrance-pack__selected-count");
    const summaryWrap = root.querySelector(".manish-fragrance-pack__summary");
    const summaryList = root.querySelector(".manish-fragrance-pack__summary-list");
    const errorEl = root.querySelector(".manish-fragrance-pack__error");
    const inputSelection = root.querySelector('input[name="properties[Fragrance Selection]"]');

    const form = root.closest("product-form")
      ? root.closest("product-form").querySelector("form")
      : root.closest("form");

    if (!form || !modal || !inputSelection) return;

    if (!modal.dataset.movedToBody) {
      document.body.appendChild(modal);
      modal.dataset.movedToBody = "true";
    }

    const addToCartBtn =
      form.querySelector('[name="add"]') ||
      form.querySelector('button[type="submit"]');

    const dynamicCheckoutWrap =
      form.querySelector(".shopify-payment-button") ||
      root.parentElement?.querySelector(".shopify-payment-button") ||
      document.querySelector(`#shopify-section-${root.dataset.sectionId} .shopify-payment-button`);

    const state = {};
    options.forEach((item) => {
      state[item.name] = 0;
    });

    let imageViewerModal = document.getElementById("manish-fragrance-pack-image-viewer");
    if (!imageViewerModal) {
      imageViewerModal = document.createElement("div");
      imageViewerModal.id = "manish-fragrance-pack-image-viewer";
      imageViewerModal.className = "manish-fragrance-pack-image-viewer";
      imageViewerModal.setAttribute("hidden", "hidden");
      imageViewerModal.innerHTML = `
        <div class="manish-fragrance-pack-image-viewer__overlay" data-image-viewer-close></div>
        <div class="manish-fragrance-pack-image-viewer__dialog" role="dialog" aria-modal="true" aria-label="Fragrance image preview">
          <button type="button" class="manish-fragrance-pack-image-viewer__close" aria-label="Close image preview" data-image-viewer-close>×</button>
          <img src="" alt="" class="manish-fragrance-pack-image-viewer__image" />
          <div class="manish-fragrance-pack-image-viewer__title"></div>
        </div>
      `;
      document.body.appendChild(imageViewerModal);
    }

    const imageViewerImage = imageViewerModal.querySelector(".manish-fragrance-pack-image-viewer__image");
    const imageViewerTitle = imageViewerModal.querySelector(".manish-fragrance-pack-image-viewer__title");
    const imageViewerCloseEls = imageViewerModal.querySelectorAll("[data-image-viewer-close]");

    function totalSelected() {
      return Object.values(state).reduce((sum, qty) => sum + qty, 0);
    }

    function flattenedSelection() {
      const arr = [];
      Object.keys(state).forEach((name) => {
        for (let i = 0; i < state[name]; i++) {
          arr.push(name);
        }
      });
      return arr;
    }

    function isValid() {
      return totalSelected() === maxSelection;
    }

    function lockPurchase() {
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.setAttribute("aria-disabled", "true");
      }

      if (dynamicCheckoutWrap) {
        dynamicCheckoutWrap.style.pointerEvents = "none";
        dynamicCheckoutWrap.style.opacity = "0.45";
      }
    }

    function unlockPurchase() {
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.removeAttribute("aria-disabled");
      }

      if (dynamicCheckoutWrap) {
        dynamicCheckoutWrap.style.pointerEvents = "";
        dynamicCheckoutWrap.style.opacity = "";
      }
    }

    function renderSummary() {
      const selected = flattenedSelection();
      summaryList.innerHTML = "";

      if (selected.length) {
        selected.forEach((name) => {
          const pill = document.createElement("span");
          pill.className = "manish-fragrance-pack__pill";
          pill.textContent = name;
          summaryList.appendChild(pill);
        });
        summaryWrap.hidden = false;
      } else {
        summaryWrap.hidden = true;
      }
    }

    function updateInputs() {
      const selected = flattenedSelection();
      inputSelection.value = selected.join(", ");
    }

    function getOptionByName(name) {
      return options.find((item) => item.name === name) || null;
    }

    function openImageViewer(image, name) {
      if (!image) return;

      imageViewerImage.src = image;
      imageViewerImage.alt = name || "Fragrance image";
      imageViewerTitle.textContent = name || "";
      imageViewerModal.hidden = false;

      document.documentElement.classList.add("manish-fragrance-pack-modal-open");
      document.body.classList.add("manish-fragrance-pack-modal-open");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }

    function closeImageViewer() {
      imageViewerModal.hidden = true;
      imageViewerImage.src = "";
      imageViewerImage.alt = "";
      imageViewerTitle.textContent = "";

      if (modal.hidden) {
        document.documentElement.classList.remove("manish-fragrance-pack-modal-open");
        document.body.classList.remove("manish-fragrance-pack-modal-open");
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
      }
    }

    function updateCardControls() {
  const total = totalSelected();

  optionsWrap.querySelectorAll(".manish-fragrance-pack__option").forEach((card) => {
    const fragrance = card.dataset.fragrance;
    const qty = state[fragrance] || 0;

    const actionArea = card.querySelector(".manish-fragrance-pack__action-area");
    if (!actionArea) return;

    // ALWAYS keep view button
    if (qty > 0) {
      actionArea.innerHTML = `
        <div class="manish-fragrance-pack__card-buttons">
          <button type="button" class="manish-fragrance-pack__card-btn manish-fragrance-pack__card-btn--view" data-action="view">
            View
          </button>
          <div class="manish-fragrance-pack__qty">
            <button type="button" data-action="minus">−</button>
            <span class="manish-fragrance-pack__qty-value">${qty}</span>
            <button type="button" data-action="plus" ${total >= maxSelection ? "disabled" : ""}>+</button>
          </div>
        </div>
      `;
    } else {
      actionArea.innerHTML = `
        <div class="manish-fragrance-pack__card-buttons">
          <button type="button" class="manish-fragrance-pack__card-btn manish-fragrance-pack__card-btn--view" data-action="view">
            View
          </button>
          <button type="button" class="manish-fragrance-pack__card-btn manish-fragrance-pack__card-btn--select" data-action="select" ${total >= maxSelection ? "disabled" : ""}>
            Select
          </button>
        </div>
      `;
    }
  });
}

    function syncUI() {
      const total = totalSelected();
      selectedCountEl.textContent = String(total);

      updateInputs();
      renderSummary();
      updateCardControls();

      if (isValid()) {
        errorEl.hidden = true;
        unlockPurchase();
      } else {
        lockPurchase();
      }
    }

    function getOptionImageHTML(image, name) {
      if (!image) return "";
      return `
        <div class="manish-fragrance-pack__image-wrap">
          <img
            src="${image}"
            alt="${name}"
            class="manish-fragrance-pack__image"
            loading="lazy"
            width="160"
            height="160"
          >
        </div>
      `;
    }

    function buildOptions() {
      optionsWrap.innerHTML = "";

      options.forEach((item) => {
        const card = document.createElement("div");
        card.className = "manish-fragrance-pack__option";
        card.dataset.fragrance = item.name;

        card.innerHTML = `
          ${getOptionImageHTML(item.image, item.name)}
          <div class="manish-fragrance-pack__option-top">
            <div class="manish-fragrance-pack__option-title">${item.name}</div>
          </div>
          <div class="manish-fragrance-pack__action-area">
            <div class="manish-fragrance-pack__card-buttons">
              <button type="button" class="manish-fragrance-pack__card-btn manish-fragrance-pack__card-btn--view" data-action="view">View</button>
              <button type="button" class="manish-fragrance-pack__card-btn manish-fragrance-pack__card-btn--select" data-action="select">Select</button>
            </div>
          </div>
        `;

        optionsWrap.appendChild(card);
      });

      optionsWrap.addEventListener("click", function (event) {
        const btn = event.target.closest("button");
        if (!btn) return;

        const card = event.target.closest(".manish-fragrance-pack__option");
        if (!card) return;

        const fragrance = card.dataset.fragrance;
        const action = btn.dataset.action;
        const currentTotal = totalSelected();
        const option = getOptionByName(fragrance);

        if (action === "view") {
          openImageViewer(option?.image || "", fragrance);
          return;
        }

        if (action === "select" && currentTotal < maxSelection) {
          state[fragrance] += 1;
          syncUI();
          return;
        }

        if (action === "plus" && currentTotal < maxSelection) {
          state[fragrance] += 1;
          syncUI();
          return;
        }

        if (action === "minus" && state[fragrance] > 0) {
          state[fragrance] -= 1;
          syncUI();
        }
      });
    }

    function openModal() {
      modal.hidden = false;
      document.documentElement.classList.add("manish-fragrance-pack-modal-open");
      document.body.classList.add("manish-fragrance-pack-modal-open");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    }

    function closeModal() {
      modal.hidden = true;

      if (imageViewerModal.hidden) {
        document.documentElement.classList.remove("manish-fragrance-pack-modal-open");
        document.body.classList.remove("manish-fragrance-pack-modal-open");
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
      }
    }

    openBtn?.addEventListener("click", openModal);
    editBtn?.addEventListener("click", openModal);

    overlayCloseEls.forEach((el) => {
      el.addEventListener("click", closeModal);
    });

    imageViewerCloseEls.forEach((el) => {
      el.addEventListener("click", closeImageViewer);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        if (!imageViewerModal.hidden) {
          closeImageViewer();
          return;
        }

        if (!modal.hidden) {
          closeModal();
        }
      }
    });

    confirmBtn?.addEventListener("click", function () {
      if (!isValid()) {
        errorEl.hidden = false;
        return;
      }
      errorEl.hidden = true;
      closeModal();
    });

    form.addEventListener("submit", function (event) {
      if (!isValid()) {
        event.preventDefault();
        event.stopPropagation();
        errorEl.hidden = false;
        openModal();
      }
    });

    if (dynamicCheckoutWrap) {
      dynamicCheckoutWrap.addEventListener(
        "click",
        function (event) {
          if (!isValid()) {
            event.preventDefault();
            event.stopPropagation();
            errorEl.hidden = false;
            openModal();
          }
        },
        true
      );
    }

    buildOptions();
    syncUI();
  }

  function initAllFragrancePacks(scope) {
    const packs = (scope || document).querySelectorAll(".manish-fragrance-pack");
    packs.forEach(initFragrancePack);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAllFragrancePacks(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAllFragrancePacks(event.target);
  });

  document.addEventListener("cart:drawer:rendered", function () {
    initAllFragrancePacks(document);
  });
})();

// ============================================================
// Added by Claude: block direct add-to-cart on collection/search
// pages for products that require fragrance/scent selection.
// Does not affect behavior on the product page itself, where the
// existing modal/validation above continues to run unchanged.
// ============================================================
(function () {
  var restrictedHandles = ["discovery-pack", "car-diffuser-refill-pack"];

  function isProductPage() {
    return window.location.pathname.indexOf("/products/") === 0;
  }

  function getProductHandle(el) {
    var wrapper = el.closest(".card-wrapper, .product-card-wrapper");
    if (!wrapper) return null;
    var anchor = wrapper.querySelector('a[href*="/products/"]');
    if (!anchor) return null;
    var match = anchor.getAttribute("href").match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  // Case 1: plain product-form submit used by single-variant products
  // (this is the path Discovery Pack and Car Diffuser Refill Pack use today)
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      if (isProductPage()) return;

      var handle = getProductHandle(form);
      if (!handle || restrictedHandles.indexOf(handle) === -1) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = "/products/" + handle;
    },
    true
  );

  // Case 2: quick-add modal opener (covers these products if they ever gain
  // a second variant and switch to the modal quick-add path)
  document.addEventListener(
    "click",
    function (e) {
      var opener = e.target.closest('modal-opener button[data-product-url]');
      if (!opener) return;
      if (isProductPage()) return;

      var urlMatch = (opener.getAttribute("data-product-url") || "").match(/\/products\/([^/?#]+)/);
      var handle = getProductHandle(opener) || (urlMatch ? urlMatch[1] : null);
      if (!handle || restrictedHandles.indexOf(handle) === -1) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = opener.getAttribute("data-product-url");
    },
    true
  );
})();
